import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-dark text-gray-300 py-12 border-t border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <i data-lucide="wrench" className="h-6 w-6 text-brand-500"></i>
                            <span className="font-bold text-xl tracking-tight text-white">Garaje Pro <span className="text-brand-500">360</span></span>
                        </div>
                        <p className="text-sm text-gray-400 mb-6">El sistema operativo de tu taller. Inventario, citas, facturación y clientes — todo conectado, nada perdido.</p>
                        <div className="flex gap-4">
                            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 hover:text-white transition-all">
                                <i data-lucide="facebook" className="w-5 h-5"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 hover:text-white transition-all">
                                <i data-lucide="instagram" className="w-5 h-5"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 hover:text-white transition-all">
                                <i data-lucide="twitter" className="w-5 h-5"></i>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Enlaces Rápidos</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#inicio" className="hover:text-brand-500 transition-colors">Inicio</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Funciones</a></li>
                            <li><a href="#nosotros" className="hover:text-brand-500 transition-colors">Beneficios</a></li>
                            <li><a href="#contacto" className="hover:text-brand-500 transition-colors">Registrar mi Taller</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Módulos</h4>
                        <ul className="space-y-2 text-sm">
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Control de Inventario</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">IA de Stock</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Agendamiento y Citas</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Historial Clínico</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Facturación Rápida</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">CRM de Clientes</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Cuentas de Cobro y Facturación</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Vista Cliente en Tiempo Real</a></li>
                            <li><a href="#servicios" className="hover:text-brand-500 transition-colors">Reportes Financieros</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">¿Listo para empezar?</h4>
                        <p className="text-sm text-gray-400 mb-4">Registra tu taller hoy y recibe tu Landing Page propia desde el día uno.</p>
                        <a href="#contacto" className="inline-block bg-brand-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-brand-500 transition-colors text-sm w-full text-center">
                            Registrar mi Taller
                        </a>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">
                    <p>© 2026 Garaje Pro 360. Todos los derechos reservados.</p>
                    <div className="flex gap-4 mt-4 md:mt-0">
                        <a href="#" className="hover:text-white transition-colors">Términos y Condiciones</a>
                        <a href="#" className="hover:text-white transition-colors">Política de Privacidad</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
